import { IconButton } from "@mui/material";

export default function ListIcon({ href, icon: IconComponent }) {
    return (
        <IconButton
            href={href}
            sx={{
                background: "rgba(255,255,255,0.6)",
                backdropFilter: "blur(10px)",
                transition: "background 0.5s ease",
                ":hover": {
                    background: "#264f62",
                    "& .iconsColor": { color: "#fff" },
                },
            }}>
            <IconComponent
                className="iconsColor"
                sx={{ color: "rgba(0, 0, 0, 0.54)" }}
            />
        </IconButton>
    );
}
